import { styled } from "@mui/system";
import { Avatar, Box, Typography } from "@mui/material";
import { TEXT_ELLIPSIS } from "../../../../../Shared/styles";

export const FeedEntrypointContainer = styled(Box)({
    display: "flex",
    width: "100%",
    alignItems: "center",
    gap: "12px",
    ...TEXT_ELLIPSIS,
});

export const GroupAvatar = styled(Avatar, {
    shouldForwardProp: (prop) => prop !== "backgroundColor",
})<{ backgroundColor: string }>(({ backgroundColor }) => ({
    backgroundColor: backgroundColor ?? "transparent",
    textTransform: "uppercase",
    width: "40px",
    height: "40px",
}));

export const FeedItemContentContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "center",
    alignSelf: "center",
    ...TEXT_ELLIPSIS,
});

export const FeedTitleContainer = styled("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    ...TEXT_ELLIPSIS,
});

export const FeedTitleTypography = styled(Typography)({
    fontSize: "1rem",
    fontWeight: "400",
    color: "var(--community-color-primary-text)",
    fontFamily: "inherit",
    ...TEXT_ELLIPSIS,
});

export const FeedSublineTypography = styled(Typography)({
    fontSize: "0.75rem",
    color: "var(--community-color-secondary-text)",
    fontFamily: "inherit",
    ...TEXT_ELLIPSIS,
});
